import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import { useBook } from '../contexts/BookContext';

export default function HomePage() {
  const navigate = useNavigate();
  const { clearBook } = useBook();

  const handleCreateStory = () => {
    clearBook(); // Clear any existing book state
    navigate('/create', { state: { newStory: true } });
  };

  return (
    <div className="max-w-4xl mx-auto text-center">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">
        Transform Your Stories with AI-Powered Magic
      </h1>
      
      <p className="text-xl text-gray-600 mb-12">
        Create, design, and publish your storybook in four simple steps.
        Let our AI wizard guide you through the entire process.
      </p>

      <div className="flex justify-center gap-4 mb-16">
        <button
          onClick={handleCreateStory}
          className="inline-flex items-center gap-2 bg-indigo-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition-colors"
        >
          <BookOpenIcon className="h-6 w-6" />
          Create Story
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        {[
          {
            step: 1,
            title: 'Create',
            description: 'Write your story with AI assistance',
          },
          {
            step: 2,
            title: 'Design',
            description: 'Choose layouts and visual styles',
          },
          {
            step: 3,
            title: 'Print',
            description: 'Preview and prepare for printing',
          },
          {
            step: 4,
            title: 'Ship',
            description: 'Publish and share your storybook',
          },
        ].map(({ step, title, description }) => (
          <div
            key={step}
            className="bg-white p-6 rounded-lg shadow-md"
          >
            <div className="w-8 h-8 bg-indigo-600 text-white rounded-full flex items-center justify-center mb-4 mx-auto">
              {step}
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
            <p className="text-gray-600">{description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}